import { render } from "./TopMenuItem.vue?vue&type=template&id=b46e8a54&ts=true"
import script from "./TopMenuItem.vue?vue&type=script&lang=ts"
export * from "./TopMenuItem.vue?vue&type=script&lang=ts"

import "./TopMenuItem.vue?vue&type=style&index=0&id=b46e8a54&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__